const YTSvg = () => {
  return (
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M11.285 6H21.585C24.5038 6 26.87 8.36618 26.87 11.285V21.585C26.87 24.5038 24.5038 26.87 21.585 26.87H11.285C8.36618 26.87 6 24.5038 6 21.585V11.285C6 8.36618 8.36618 6 11.285 6ZM13.1507 12.7029H19.4792C20.8419 12.7029 21.953 13.8078 21.953 15.1766V18.123C21.953 19.4857 20.8481 20.5967 19.4792 20.5967H13.1507C11.788 20.5967 10.677 19.4918 10.677 18.123V15.1766C10.677 13.8139 11.7819 12.7029 13.1507 12.7029ZM15.1518 14.8022V18.5834L18.2516 16.6498L15.1518 14.8022Z" fill="white"/>
</svg>
  )}

export default YTSvg
